import { Task } from "gantt-task-react";
import { IProject } from "../../../shared/models/Project.model";
import ProjectTask, { IProjectTask } from "../../../shared/models/ProjectTasks.model";
import AppStore from "../../../shared/stores/AppStore";

export const ItemTypes = {
    TASK: 'task'
}

// export function initTasks() {
//     const currentDate = new Date();
//     const tasks: Task[] = [
//         {
//             start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
//             end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 15),
//             name: "Some Project",
//             id: "ProjectSample",
//             progress: 25,
//             type: "project",
//             hideChildren: false,
//             displayOrder: 1,
//         },
//         {
//             start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
//             end: new Date(
//                 currentDate.getFullYear(),
//                 currentDate.getMonth(),
//                 2,
//                 12,
//                 28
//             ),
//             name: "Idea",
//             id: "Task 0",
//             progress: 45,
//             type: "task",
//             project: "ProjectSample",
//             displayOrder: 2,
//         },
//         {
//             start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2),
//             end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 4, 0, 0),
//             name: "Research",
//             id: "Task 1",
//             progress: 25,
//             dependencies: ["Task 0"],
//             type: "task",
//             project: "ProjectSample",
//             displayOrder: 3,
//         },
//         {
//             start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 4),
//             end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 8, 0, 0),
//             name: "Discussion with team",
//             id: "Task 2",
//             progress: 10,
//             dependencies: ["Task 1"],
//             type: "task",
//             project: "ProjectSample",
//             displayOrder: 4,
//         },
//         {
//             start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 8),
//             end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 9, 0, 0),
//             name: "Developing",
//             id: "Task 3",
//             progress: 2,
//             dependencies: ["Task 2"],
//             type: "task",
//             project: "ProjectSample",
//             displayOrder: 5,
//         },
//         {
//             start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 8),
//             end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 10),
//             name: "Review",
//             id: "Task 4",
//             type: "task",
//             progress: 70,
//             dependencies: ["Task 2"],
//             project: "ProjectSample",
//             displayOrder: 6,
//         },
//         {
//             start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 15),
//             end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 15),
//             name: "Release",
//             id: "Task 6",
//             progress: currentDate.getMonth(),
//             type: "milestone",
//             dependencies: ["Task 4"],
//             project: "ProjectSample",
//             displayOrder: 7,
//         },
//         {
//             start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 18),
//             end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 19),
//             name: "Party Time",
//             id: "Task 9",
//             progress: 27,
//             isDisabled: false,
//             type: "task",
//         },
//     ];
//     return tasks;
// }

export function ganttChartProjects(projects: IProject[]): Task | any {
    return projects.map((project) => {
        const { startDate, endDate, projectName, id, ...all } = project;
        return {
            start: new Date(startDate),
            end: new Date(endDate),
            type: "project",
            // hideChildren: true,
            id,
            name: projectName,
            project: projectName,
            ...all
        }
    });
}

export function ganttChartTasks(tasks: IProjectTask[], store: AppStore): Task | any {
    const projects = store.projectManagement.all.map((p) => p.asJson).map((project) => {
        const { startDate, endDate, projectName, id, ...all } = project;
        return {
            start: new Date(startDate),
            end: new Date(endDate),
            type: "project",
            hideChildren: false,
            id,
            name: projectName,
            project: projectName,
            ...all
        }
    });

    const task: any = tasks.map(task => {
        const { taskName, startDate, endDate, projectId, type, status, dependencies, ...all } = task;
        const project = store.projectManagement.getItemById(projectId)?.asJson.projectName;
        const dep = (task.type === "milestone") ? store.projectTask.getDependenciesById(task.id) : "";
        const color = status === "todo" ? "red" : status === "in-progress" ? "orange" : status === "in-review" ? "purple" : status === "done" ? "green" : "gray";
        return {
            start: new Date(startDate),
            end: new Date(endDate),
            name: taskName,
            projectId,
            project,
            type: type ?? "task",
            dependencies: (dependencies?.length) ? [...dependencies, dep] : [dep],
            ...all,
            status,
            styles: { backgroundColor: type !== "milestone" ? color : "orange", progressColor: '#0000001f', progressSelectedColor: '#ff9e0d' }
        }
    })

    return projects.concat(task).sort((a: any, b: any) => {
        const projectA = a.project?.toUpperCase();
        const projectB = b.project?.toUpperCase();
        if (projectA < projectB) {
            return -1;
        }
        if (projectA > projectB) {
            return 1;
        }
        return 0;
    })
}

export function ganttProjectTasks(tasks: IProjectTask[], store: AppStore): Task | any {
    const task = tasks.map(task => {
        const { taskName, startDate, endDate, projectId, type, status, dependencies, ...all } = task;
        const project = store.projectManagement.getItemById(projectId)?.asJson.projectName;
        const dep = (task.type === "milestone") ? store.projectTask.getDependenciesById(task.id) : "";
        const color = status === "todo" ? "red" : status === "in-progress" ? "orange" : status === "in-review" ? "purple" : status === "done" ? "green" : "gray";
        return {
            start: new Date(`${startDate}`),
            end: new Date(`${endDate}`),
            name: taskName,
            projectId,
            project,
            type: type ?? "task",
            dependencies: (dependencies?.length) ? [...dependencies, dep] : [dep],
            ...all,
            status,
            styles: { backgroundColor: type !== "milestone" ? color : "orange", progressColor: '#0000001f', progressSelectedColor: '#ff9e0d' }
        }
    })
    return task;
}